'use client';

import { graphql } from 'src/gql';

export const CreateDataExportMutation = graphql(/* GraphQL */ `
  mutation CreateDataExport(
    $resourceType: String!
    $format: String!
    $columnIds: [String!]!
    $filters: [ExportFilterInput!]
    $sorting: [ExportSortInput!]
    $globalFilter: String
  ) {
    createDataExport(
      input: {
        resourceType: $resourceType
        format: $format
        columnIds: $columnIds
        filters: $filters
        sorting: $sorting
        globalFilter: $globalFilter
      }
    ) {
      dataExport {
        id
        status
      }
      errors
    }
  }
`);

export const DataExportQuery = graphql(/* GraphQL */ `
  query DataExport($id: ID!) {
    dataExport(id: $id) {
      id
      status
      downloadUrl
      errorMessage
      filename
    }
  }
`);
